import React from "react";
import DataTable from "react-data-table-component";
import { Toaster, toast } from "react-hot-toast";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import CreateEmailFormatModal from "../Components/CreateEmailFormatModal";
import EditEmailFormatModal from "../Components/EditEmailFormatModal";
import { useEmailFormatTable } from "../hooks/useEmailFormatTable";
import { getEmailFormatTableColumns } from "../Components/EmailFormatTableColumns";
import { EmailFormatFormData } from "../types/emailFormat.types";
import OverlayLoader from "../Components/OverlayLoader";

const EmailFormatTable: React.FC = () => {
  const {
    isSidebarCollapsed,
    toggleSidebar,
    isLoading,
    loading,
    error,
    searchText,
    setSearchText,
    filteredEmailFormats,
    fetchEmailFormatData,
    isModalOpen,
    setIsModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editEmailFormatData,
    setEditEmailFormatData,
    selectedRows,
    toggleCleared,
    handleRowSelected,
    handleEdit,
  } = useEmailFormatTable();

  const handleCreateEmailFormat = (data: EmailFormatFormData) => {
    console.log("Creating email format:", data);
    toast.success(`Email format created: ${data.subject}`);
    fetchEmailFormatData();
  };

  const handleEditSubmit = (updatedData: EmailFormatFormData) => {
    console.log("Updated email format data:", updatedData);
    setIsEditModalOpen(false);
    setEditEmailFormatData(null);
    fetchEmailFormatData();
    toast.success("Email format updated successfully");
  };

  const columns = getEmailFormatTableColumns(handleEdit);

  // if (loading) {
  //   return <div className="p-4 text-center">Loading email formats...</div>;
  // }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{
          zIndex: 10000,
        }}
      />
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />

        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">Email Formats List</div>
                      <div>
                        <input
                          type="text"
                          placeholder="Search by Type Name or Subject"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          className="demo-btn btn btn-outline-primary btn-sm"
                          onClick={() => setIsModalOpen(true)}
                        >
                          +Add Email Format
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <DataTable
                        columns={columns}
                        data={filteredEmailFormats}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        //noDataComponent="No email formats found"
                        selectableRows
                        selectableRowsComponentProps={{
                          className: "custom-checkbox",
                        }}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CreateEmailFormatModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSubmit={handleCreateEmailFormat}
            />
            <EditEmailFormatModal
              isOpen={isEditModalOpen}
              onClose={() => {
                setIsEditModalOpen(false);
                setEditEmailFormatData(null);
              }}
              onSubmit={handleEditSubmit}
              editEmailFormatData={editEmailFormatData}
            />
          </main>
        </div>
        <Footer />
      </div>
      <OverlayLoader
        loading={loading}
        message="Loading Data"
        submessage="This might take a moment..."
      />
    </div>
  );
};

export default EmailFormatTable;
